import type { BookingProcessingLabels } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export const processingLabelsFallback: BookingProcessingLabels = {
  internalName: '',
  loadingLabel: '',
  refreshingSessionLabel: '',
  updatingCartLabel: '',
  savingScenesLabel: '',
  savingAddOnsLabel: '',
  savingScheduleLabel: '',
  updatingSessionLabel: '',
  placingOrderLabel: '',
  processingOrderLabel: '',
  loadingLocationsLabel: '',
  loadingAvailabilityLabel: '',
  loadingPresentationAvailabilityLabel: ''
}
